export enum EOutgoingCallType {
   OUTBOUND_DIRECT = "OUTBOUND_DIRECT",
   DIALER_PREVIEW = "DIALER_PREVIEW",
   AGENDA = "AGENDA",
}
